import { findDOMNode } from 'react-dom';
import { DropTarget } from 'react-dnd';
import { ItemTypes } from 'constants/itemTypes';

const sectionTarget = {
  hover(props, monitor, component) {
    const { index } = monitor.getItem();
    const hoverIndex = props.index;

    if (index !== hoverIndex) {
      // eslint-disable-next-line react/no-find-dom-node
      const { bottom, top } = findDOMNode(component).getBoundingClientRect();
      const hoverMiddleY = (bottom - top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - top;

      if (index < hoverIndex && hoverClientY < hoverMiddleY) return;
      if (index > hoverIndex && hoverClientY > hoverMiddleY) return;

      props.order(index, hoverIndex);
      monitor.getItem().index = hoverIndex;
    }
  },
  drop(props, monitor, component) {
    return {
      position: monitor.getItem().index + 1,
    };
  },
};

const collect = connector => ({
  connectDropTarget: connector.dropTarget(),
});

export default DropTarget(ItemTypes.SECTION, sectionTarget, collect);
